var _circle, _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1875,
    cy: 25.1836,
    r: 25,
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1102_750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.76562,
    y: 9.68359,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1102_750)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1102_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7656 23.8555H28.9844V25.8086H20.7656V23.8555ZM20.7656 27.543H28.9844V29.4961H20.7656V27.543ZM20.7656 20.1055H28.9844V22.0586H20.7656V20.1055Z",
    fill: "#F6EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9844 13.7461L27.3281 12.6211L24.8906 13.7461L22.2812 12.6211L19.8281 13.7461L16.1094 12.1836V37.1836L19.8281 35.6211L22.2812 36.6992L24.8906 35.6211L27.3281 36.6992L29.9844 35.6211L33.4219 37.1836V12.1836L29.9844 13.7461ZM31.4531 34.2305L30.0156 33.5898L27.375 34.668L24.9219 33.543L22.2969 34.6211L19.875 33.543L18.0781 34.2773V15.0898L19.875 15.8242L22.2969 14.7461L24.9219 15.8242L27.375 14.7461L30.0156 15.8242L31.4531 15.1836V34.2305Z",
    fill: "#F6EFE9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1102_750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(12.2656 12.1836)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.5bfc94717c64fdb18a76ad145617f8fa.svg";
export { ForwardRef as ReactComponent };